export default __webpack_public_path__ + "static/threejs-a65866b89bd58498227f9a2838810b2c.svg";